import React from "react";

export function Btn({ children, onClick, className = "", ...props }) {
  return (
    <>
      <button
        onClick={onClick}
        className={`bg-[#1234CD] w-30 text-white px-4 py-2 rounded-lg disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        {...props}
      >
        {children}
      </button>
    </>
  );
}

export function BorderBtn({ children, onClick, className = "", ...props }) {
  return (
    <>
      <button
        onClick={onClick}
        className={`border-[#1234CD] border lg:w-44 text-[#1234CD] px-4 py-4 rounded-lg disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        {...props}
      >
        {children}
      </button>
    </>
  );
}

export default function ButtonTag({ label }) {
  return (
    <button className="px-3 py-1 border border-[#3C60FFB2] rounded-lg">
      <span className="text-sm text-black">{label}</span>
    </button>
  );
}

export function RedBtn({ children, onClick, className = "", ...props }) {
  return (
    <>
      <button
        className={`bg-[#E3403333] w-40 text-[#E34033] px-4 py-3 rounded-md disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    </>
  );
}

export function RoundedBtn({ children, onClick, className = "", ...props }) {
  return (
    <>
      <button
        className={`rounded-xl text-white py-[16px] bg-[#1234CD] w-[180px] h-[60px] mt-10 text-[16px] font-[] disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    </>
  );
}

export function SmallRoundedBtn({ children, onClick, className = "", ...props }) {
  return (
    <>
      <button
        className={`rounded-lg text-white py-4 bg-[#1234CD] w-44 text-[16px] font-[] disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    </>
  );
}

export function SimpleButton({ children, onClick, className, ...props }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function QueryButton({ children, bgcolor, ...props }) {
  const background = bgcolor || "bg-[#1234CD] ";
  return (
    <>
      <button
        className={`rounded-lg ${background} text-white  cursor-pointer`}
        {...props}
      >
        {children}
      </button>
    </>
  );
}

export function SmallQueryButon({ children }) {
  return (
    <>
      <button className=" text-[#1234CD] text-sm"> {children} </button>
    </>
  );
}
